import React from "react";

import Typography from "@components/shared/Typography";

import { useTranslation } from "@lib/i18n";

import { useCEESubsidySelector } from "@redux/reducers/appConfig";

const CEESubsidyPanel = () => {
  const { t } = useTranslation();
  const ceeSubsidy = useCEESubsidySelector();

  return (
    <div className="w-full max-w-pageContent m-auto px-2 md:px-8 my-8">
      <div className="w-full max-w-pageContent bg-primaryDark rounded-md px-4 py-2">
        <Typography className="text-xs text-primaryLight">
          {t("ceeSubsidyNetPriceModal.text", {
            amount: ceeSubsidy?.discountAmount || 0,
          })}
        </Typography>
      </div>
    </div>
  );
};

CEESubsidyPanel.propTypes = {};

export default CEESubsidyPanel;
